/**
 * Given each item's right-edge offset (px, relative to the row start, already
 * accounting for inter-item gaps), returns how many leading items fit within
 * `availablePx`. While any items would remain hidden, `moreReservePx` is kept
 * free for the trailing "+N more" affordance; the final item needs no reserve.
 *
 * Pure so the legend's overflow math can be unit-tested without a real layout.
 * @see ./ChannelLegend.tsx
 */
export function countFittingItems(
  rightEdges: number[],
  availablePx: number,
  moreReservePx: number,
): number {
  let count = 0
  for (let i = 0; i < rightEdges.length; i++) {
    const reserve = i < rightEdges.length - 1 ? moreReservePx : 0
    if (rightEdges[i] + reserve > availablePx) break
    count++
  }
  return count
}
